// extracted by mini-css-extract-plugin
module.exports = {"sr-only":"aed17b9412--sr-only--GOyRg"};